import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { isNil } from 'lodash';

import { ExecIVR, ExecIVRSchema } from '@pwp-common';

import { getFieldValuesFromFormInComponent } from '../../../../common/objects/form-helper';
import { KVPair } from '../../../../common/objects/kvpair';
import { VRCEditor } from '../../../generic/abstract-classes/vrc-editor';

@Component({
  selector: 'app-vrc-editor-exec-ivr',
  templateUrl: './vrc-editor-exec-ivr.component.html',
  styleUrls: ['./vrc-editor-exec-ivr.component.css'],
})
export class VrcEditorExecIvrComponent extends VRCEditor<ExecIVR> implements OnInit {
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  // State
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  selectedIVRKVPair: KVPair<ExecIVR>;

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Lifecycle
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(
    // @ts-ignore
    private _changeDetectorRef: ChangeDetectorRef,
    private formBuilder: UntypedFormBuilder,
  ) {
    super(_changeDetectorRef);
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Read Form
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  getObjFromForm() {
    const parameters = getFieldValuesFromFormInComponent(
      undefined,
      [ExecIVRSchema.numRetriesAllowed],
      ExecIVRSchema.Defaults,
      this,
    );

    parameters[ExecIVRSchema.ivrId] = this.selectedIVRKVPair?.value?.getId() || ExecIVRSchema.Defaults.ivrId;

    const value = new ExecIVR(parameters);
    return new KVPair({ id: this.obj.id, value });
  }

  ///////////////////////////////////////////////////////////////////////////////////////////
  // Write Form
  ///////////////////////////////////////////////////////////////////////////////////////////

  setFormFromObj(obj: KVPair<ExecIVR>) {
    // Init Form
    const formConfig = {} as any;
    formConfig[ExecIVRSchema.numRetriesAllowed] = [
      obj.value!.getNumRetriesAllowed(),
      [Validators.max(10), Validators.min(1)],
    ];

    this.form = this.formBuilder.group(formConfig);

    // Init other state
    this.selectedIVRKVPair = new KVPair({ id: obj.value!.getIVRId() });
  }

  ///////////////////////////////////////////////////////////////////////////////////////////
  // Form: Getters
  ///////////////////////////////////////////////////////////////////////////////////////////

  get numRetriesAllowed(): AbstractControl | null {
    return this.form.get(ExecIVRSchema.numRetriesAllowed);
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Is Valid Obj
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  isValidObjScoper = (): boolean => this.isValidObj();

  isValidObj() {
    if (!super.isValidObj()) {
      return false;
    }

    if (isNil(this.selectedIVRKVPair?.value)) {
      return false;
    }

    return true;
  }
}
